import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import type { CheckboxChangeEvent } from "primereact/checkbox";

interface IntroDialogProps {
  visible: boolean;
  onHide: () => void;
  dontShowAgain: boolean;
  onDontShowAgainChange: (checked: boolean) => void;
  title?: string;
  message?: string;
  buttonLabel?: string;
  onlyStrengths?: boolean;
}

export const IntroDialog = ({
  visible,
  onHide,
  dontShowAgain,
  onDontShowAgainChange,
  title = "We've Got You Started",
  message = "We reviewed your group's assessment results and created a custom assignment to support their learning. Feel free to make changes or assign it as is.",
  buttonLabel = "Next",
  onlyStrengths = false,
}: IntroDialogProps) => {
  return (
    <Dialog
      id="intro-dialog"
      data-testid="intro-dialog"
      header={title}
      visible={visible}
      onHide={onHide}
      footer={
        <Button
          id="intro-next-button"
          data-testid="intro-next-button"
          label={buttonLabel}
          onClick={onHide}
        />
      }
      blockScroll
      maskStyle={{ backdropFilter: "blur(5px)" }}
      style={{ width: "500px" }}
    >
      <div className="my-4">
        {onlyStrengths && (
          <p className="mb-4" data-testid="strengths-only-message">
            Congratulations! Everyone in this Assessment has scored in the Strength category.
          </p>
        )}
        <p id="intro-message" data-testid="intro-message">
          {message}
        </p>
        <div className="mt-4 flex items-center">
          <Checkbox
            id="dont-show-again-checkbox"
            data-testid="dont-show-again-checkbox"
            inputId="dontShowAgain"
            checked={dontShowAgain}
            onChange={(e: CheckboxChangeEvent) => onDontShowAgainChange(e.checked ?? false)}
          />
          <label
            htmlFor="dontShowAgain"
            className="ml-2"
            id="dont-show-again-label"
            data-testid="dont-show-again-label"
          >
            Don&apos;t show this message again
          </label>
        </div>
      </div>
    </Dialog>
  );
};
